import React from "react";
import { Send } from "lucide-react";
import { useNewsletter } from "../../hooks/useNewsletter";

export default function FooterNewsletter() {
    const { email, setEmail, loading, onSubscribe } = useNewsletter();

    return (
        <div
            data-testid="footer-newsletter"
            className="xpo-glass p-8 lg:p-10 mb-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6"
        >
            <div className="max-w-xl">
                <p className="overline mb-2">Market Pulse</p>
                <h3 className="text-2xl lg:text-3xl font-bold text-white tracking-tight">
                    Weekly research, delivered Sunday night.
                </h3>
                <p className="text-slate-400 mt-2 text-sm">
                    Macro setups, key levels, and event calendar — for traders
                    who plan before they click.
                </p>
            </div>
            <form onSubmit={onSubscribe} className="flex w-full lg:w-auto gap-3">
                <input
                    data-testid="footer-newsletter-email"
                    type="email"
                    required
                    placeholder="trader@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-[#050814] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-slate-500 focus:border-[#A6E3DC] focus:outline-none w-full lg:w-72"
                />
                <button
                    data-testid="footer-newsletter-submit"
                    type="submit"
                    disabled={loading}
                    className="btn-primary"
                >
                    <Send size={16} /> {loading ? "Joining…" : "Subscribe"}
                </button>
            </form>
        </div>
    );
}
